import { fetch } from 'src/lib/services/Fetcher'

export const getModelsFetcher = projectId => {
  return fetch({ method: 'GET', url: `projects/${projectId}/models` })
}



// WEBPACK FOOTER //
// ./src/global/fetchers/getModels.js